import { useEffect, useState } from 'react';

/** Seuil unique partagé avec les media queries de styles.css. */
export const MOBILE_BREAKPOINT = 768;

/**
 * Vrai en dessous de 768 px. Le CSS seul ne suffisait plus pour la navigation :
 * la barre du bas et la feuille « Plus » n'ont pas le même balisage que le rail
 * de gauche, et dupliquer les deux dans le DOM aurait dupliqué les liens actifs
 * (et les cibles de test). On rend donc l'un OU l'autre.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', onChange);
    setIsMobile(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}

/**
 * Sur mobile le panneau de détail passe SOUS la liste (il n'y a pas de place
 * pour une colonne de droite) : toucher une ligne ne semblait rien faire, le
 * détail s'ouvrant hors écran, une vingtaine de lignes plus bas. On l'amène
 * donc dans le champ de vision.
 */
export function useScrollToDetail(id: number | null): void {
  const isMobile = useIsMobile();
  useEffect(() => {
    if (!isMobile || id == null) return;
    const t = window.setTimeout(() => {
      document.querySelector('.devis-detail')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 80);
    return () => window.clearTimeout(t);
  }, [id, isMobile]);
}
